import { createFileRoute } from '@tanstack/react-router';

import { ChatProvider } from '@/components/Chat/ChatContext';
import { OrgDocLayout } from '@/components/OrgDocs/OrgDocLayout';
import { MemoryTunerProvider } from '@/contexts/MemoryTunerContext';
import { PageProvider } from '@/contexts/PageContext';
import { orgDocsBackSearchSchema } from '@/routes/$organizationName/org-docs/index';

export const Route = createFileRoute('/$organizationName/org-docs/$pageVersionNodeId')({
  component: OrgDocPage,
  validateSearch: orgDocsBackSearchSchema,
});

function OrgDocPage() {
  const { organizationName, pageVersionNodeId } = Route.useParams();
  const backSearch = Route.useSearch();

  return (
    <PageProvider pageVersionNodeId={pageVersionNodeId}>
      <MemoryTunerProvider>
        <ChatProvider>
          <OrgDocLayout
            backSearch={backSearch}
            organizationName={organizationName}
            pageVersionNodeId={pageVersionNodeId}
          />
        </ChatProvider>
      </MemoryTunerProvider>
    </PageProvider>
  );
}
